<template>
  <el-dialog
    show-close
    width="1000px"
    title="附加费设置"
    destroy-on-close
    top="10vh"
    :visible="visible"
    v-el-dialog-drag
    :close-on-click-modal="false"
    @close="close"
  >
    <fee-setting-edit-form
      ref="editForm"
      :contractCarrierCode="contractCode"
      :contractCarrierFeeCode="contractFeeCode"
    />
    <span slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import FeeSettingEditForm from './index'
export default {
  components: {
    FeeSettingEditForm,
  },
  props: {
    visible: Boolean,
    contractCarrierCode: String,
    contractCarrierFeeCode: String,
  },
  computed: {
    contractCode() {
      return this.contractCarrierCode
    },
    contractFeeCode() {
      return this.contractCarrierFeeCode
    },
  },
  methods: {
    confirm() {
      this.$refs.editForm.save().then(() => {
        this.$emit('success')
        this.close()
      })
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
